import _default from './Advertisement';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/views/Advertisement/index.js
// module id = 1569
// module chunks = 1